import { Base64 } from 'js-base64';
import { post2faCodeResponse } from './post2faCodeApiCall';
import fetchWebApi from 'api/fetchWebApi';

export interface PostTokenBasicPayload {
  emailOrPersonalId: string;
  password: string;
  fingerprint: string;
}

// 2faOptionalComment: Remove changes related 2fa options when BE deployment is done on PROD [zaquiel]
export interface PostTokenBasicResponse extends post2faCodeResponse {
  verificationId: string;
}

const postTokenBasicApiCall = async (
  payload: PostTokenBasicPayload,
): Promise<PostTokenBasicResponse> => {
  const basicToken = Base64.encode(
    `${payload.emailOrPersonalId.toLowerCase()}:${payload.password}`,
  );

  const data = await fetchWebApi(`/token/basic`, undefined, {
    method: 'post',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Authorization: `Basic ${basicToken}`,
      'X-Device-Id': payload.fingerprint,
      'Content-Type': 'application/json',
    },
  });

  return data;
};

export default postTokenBasicApiCall;
